import React, { useCallback, useEffect } from 'react';
import { PlaylistEnum } from '../enum/PlaylistEnum';
import { PlayListPromoverAlfabetizacao } from '../helpers/PlayListPromoverAlfabetizacao';
import { IPlaylistVideos } from '../interfaces/IPlaylistVideos';
import useTypePlayList from './useTypePlayList';
import { PlayListSeminario } from '../helpers/PlayListSeminario';

const useFetchPlayList = () => {
    const { handleTypePlayList, id } = useTypePlayList();
    const [data, setData] = React.useState<IPlaylistVideos[] | null>(null);
    const [isLoading, setIsLoading] = React.useState(true);
    const [indexVideo, setIndexVideo] = React.useState<number>(0);

    /**
     * @param video - The video to be selected.
     * Sets the index of the video in the playlist based on its ID.
     */
    const setVideoSelected = useCallback(
        (video: IPlaylistVideos) => {
            setIndexVideo(data?.findIndex(v => v.idVideo === video.idVideo) ?? 0);
        },
        [data]
    );

    useEffect(() => {
        const params = handleTypePlayList();

        let playlistData: IPlaylistVideos[] | null = null;

        switch (params) {
            case PlaylistEnum.SEMINARIO:
                playlistData = PlayListSeminario;
                break;
            case PlaylistEnum.PROMOVER_ALFABETIZACAO:
                playlistData = PlayListPromoverAlfabetizacao;
                break;
            default:
                playlistData = null;
        }
        setData(playlistData);
        setIsLoading(false);
    }, [id]);

    return {
        playlist: data,
        isLoading,
        setVideoSelected,
        indexVideo,
    };
};

export default useFetchPlayList;
